import { Button } from '@emailforge/ui';
import { useParams } from 'react-router-dom';

import { TopBar } from '@/components/layout/TopBar';
import { Icon } from '@/components/ui/icons';
import { useGetTemplateQuery } from '@/features/templates/templatesApi';
import { t } from '@/lib/i18n';

export function CodeScreen() {
  const { templateId = '' } = useParams();
  const { data, isLoading } = useGetTemplateQuery(templateId, { skip: !templateId });
  const source = data?.latestVersion?.jsxSource ?? '// template has no versions yet';

  const download = () => {
    const blob = new Blob([source], { type: 'text/typescript' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${data?.slug ?? 'template'}.tsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const copy = () => navigator.clipboard.writeText(source);

  return (
    <>
      <TopBar
        crumbs={[t('nav.templates'), data?.name ?? '…', 'Code']}
        right={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button size="sm" onClick={copy}>
              <Icon.copy size={13} /> Copy
            </Button>
            <Button size="sm" onClick={download}>
              <Icon.arrowDown size={13} /> Export .tsx
            </Button>
          </div>
        }
      />
      <div style={{ flex: 1, padding: 24, overflowY: 'auto', background: 'var(--paper-2)' }}>
        <div
          className="mf-card"
          style={{
            maxWidth: 980,
            margin: '0 auto',
            padding: 20,
            background: 'var(--code-bg)',
            overflow: 'auto',
          }}
        >
          <div
            className="mono"
            style={{
              fontSize: 10.5,
              color: 'var(--ink-3)',
              textTransform: 'uppercase',
              letterSpacing: 0.08,
              marginBottom: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <span>{data?.slug ?? 'template'}.tsx · React Email · generated</span>
            <span style={{ flex: 1 }} />
            {isLoading && <span>Loading…</span>}
          </div>
          <pre
            className="mono"
            style={{
              margin: 0,
              fontSize: 12,
              lineHeight: 1.65,
              color: 'var(--code-ink)',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {source}
          </pre>
        </div>
      </div>
    </>
  );
}
